<template>
	<div class="Identity sw-container">
		<div class="common-nav">
			<span class="s1">您的位置</span>
			<span class="s2">|</span>
			<span class="s3">资质认证</span>
		</div>
		<div class="Identity-main">
			<div class="Identity-title">资质认证 </div>
			<div class="Identity-box">
				<Form class="Identity-form" ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
					<FormItem label="资质类型" prop="type">
						<Select v-model="formValidate.type" placeholder="请选择资质类型">
							<Option value="beijing">New York</Option>
							<Option value="shanghai">London</Option>
							<Option value="shenzhen">Sydney</Option>
						</Select>
					</FormItem>
					<FormItem label="证书编号" prop="num">
						<Input v-model="formValidate.num" placeholder="请输入证书编号"></Input>
					</FormItem>
					<div class="Identity-btn">确认</div>
				</Form>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Identity',
		components: {},
		data() {
			return {
				formValidate: {},
				ruleValidate: {
					type: [{
						required: true,
						message: '请选择资质类型',
						trigger: 'change'
					}],
					num: [{
						required: true,
						message: '请输入证书编号',
						trigger: 'blur'
					}]
				}
			}
		},
		created() {},
		computed: {},
		methods: {

		},
		watch: {}
	}
</script>

<style lang="scss">
	.Identity {
		padding-bottom: 30px;
		&-main {
			height: 600px;
			background: #fff;
			padding: 18px 0 0 25px;
		}
		&-title {
			font-size: 16px;
			border-left: 2px solid #41BF67;
			padding-left: 10px;
			line-height: 1;
		}
		&-form {
			width: 380px;
		}
		&-box {
			padding-top: 130px;
			display: flex;
			justify-content: center;
		}
		&-btn {
			height: 40px;
			line-height: 40px;
			cursor: pointer;
			background: #37BC5F;
			color: #fff;
			font-size: 14px;
			text-align: center;
			margin-top: 38px;
		}
		&-btn:hover {
			background: rgba(55, 188, 95,.7);
		}
		.ivu-form-item-required .ivu-form-item-label:before {
			content: ''
		}
		.ivu-form .ivu-form-item-label {
			float: none;
			display: block;
			text-align: left;
			color: #222222;
			font-size: 14px;
		}
		.ivu-form-item-content {
			margin-left: 0 !important;
		}
		.ivu-input {
			height: 40px;
		}
		.ivu-select-single .ivu-select-selection {
			height: 40px;
		}
		.ivu-select-single .ivu-select-selection .ivu-select-placeholder,
		.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
			height: 40px;
			line-height: 40px;
		}
	}
</style>